import { Instagram, Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-foreground text-background">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-20">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-background/60">
              Ascending Trends Educational &amp; Behavioral Consulting
            </p>
            <p className="mt-4 font-serif text-5xl md:text-7xl font-light leading-none">
              Dr. Joanne
              <br />
              Hill Powell
            </p>
          </div>
          <div className="flex gap-4">
            {[
              { icon: Linkedin, href: "https://www.linkedin.com/in/joanne-hill-powell/", label: "LinkedIn" },
              { icon: Instagram, href: "https://www.instagram.com/dr.joanne_hill_powell/", label: "Instagram" },
              { icon: Mail, href: "mailto:drpowell@ascendingtrends.org", label: "Email" },
            ].map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-${label.toLowerCase()}`}
                aria-label={label}
                className="flex h-12 w-12 items-center justify-center rounded-full border border-background/20 transition-all duration-300 hover:bg-primary hover:border-primary hover:-translate-y-1"
              >
                <Icon className="h-5 w-5" strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-16 border-t border-background/15 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <p className="text-sm text-background/60">
            © {new Date().getFullYear()} Dr. Joanne Hill Powell · drjoannepowell.com
          </p>
          <a href="/admin" data-testid="footer-admin" className="text-xs text-background/40 hover:text-background/70 transition-colors">
            Admin
          </a>
        </div>

        <p className="mt-8 max-w-4xl text-xs leading-relaxed text-background/45">
          Professional coaching is educational and developmental in nature and does
          not constitute mental-health treatment, legal advice, financial advice,
          clinical supervision, or certification. Educational reading services do
          not replace diagnosis, psychological evaluation, medical care, or services
          delivered by a child's licensed clinical providers.
        </p>
      </div>
    </footer>
  );
}
